import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export const AggregatedPower = React.memo((props) => {
  const { powerData } = props;
  const { colors } = useTheme();
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Aggregated Power(W) </H9TitleSmall>
      </Box>
      <>
        <List
          sx={{
            width: "100%",
            backgroundColor: colors.background.accent,
            borderRadius: "1.5rem",
          }}
        >
          {Object.keys(powerData).length > 0 ? (
            <ListItem>
              <ListItemText
                sx={{ color: colors.text.muted }}
              >
                {
                  powerData?.aggregatedPowerConsumptionLastHour
                }
              </ListItemText>
            </ListItem>
          ) : (
            <ListItem>
              <ListItemText 
                secondary="Aggregated power data unavailable"
                sx={{
                  "& .MuiListItemText-secondary": {
                    color: colors.text.muted,
                  },
                }}
              />
            </ListItem>
          )}
        </List>
      </>
    </Box>
  );
});
